module.exports = __webpack_public_path__ + "static/media/instructions1.d184b7ef.PNG";